<template>
  <div class="result-table-mobile">
    <div class="result-table-mobile__row">
      <div
        @click="openInputPopup()"
        class="result-table-mobile__col result-table-mobile__col--input"
      >
        <div class="result-table-mobile__label">{{ $t('message.sellPrice') }}</div>
        <price :currency="result.currency" :num="result.priceOfSq" class="result-table-mobile__price" size="lg"/>
      </div>
      <div class="result-table-mobile__col">
        <div class="result-table-mobile__label">{{ $t('message.costPrice') }}</div>
        <price :currency="result.currency" :num="result.costOfSq" class="result-table-mobile__price" size="lg"/>
      </div>
      <div class="result-table-mobile__col">
        <div class="result-table-mobile__label">{{ $t('message.profit') }}</div>
        <price :currency="result.currency" :num="result.profitBySq" class="result-table-mobile__price" size="lg"/>
      </div>
      <div class="result-table-mobile__col">
        <div class="result-table-mobile__label">{{ $t('message.volumeOfProduction') }}</div>
        <value :num="result.productionVolume" class="result-table-mobile__price" :measure="$t('measure.m2')" size="lg"/>
      </div>
    </div>
    <popup-input
      :period="period"
      :show="$data.$popupInputIsOpen"
      @close="closeInputPopup"
      v-bind="source.price"
      variant="price"
    />
  </div>
</template>

<script>
  import Price from "../Price";
  import {mapGetters, mapState} from "vuex";
  import PopupInput from "./PopupInput";
  import Value from "../Value";

  export default {
    name: "ResultTableMobile",
    components: {Value, PopupInput, Price},
    data() {
      return {
        $popupInputIsOpen: false
      }
    },
    computed: {
      ...mapState('mobile', [
        'source', 'period'
      ]),
      ...mapGetters('mobile', [
        'result'
      ])
    },
    methods: {
      openInputPopup() {
        this.$data.$popupInputIsOpen = true;
      },
      closeInputPopup() {
        this.$data.$popupInputIsOpen = false;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .result-table-mobile {
    &__row {
      display: flex;
      flex-flow: row wrap;
      justify-content: stretch;
      align-content: stretch;
      align-items: stretch;
    }

    &__col {
      flex: 1 1 auto;
      width: 50%;
      margin-bottom: 0.5em;

      &--input {
        text-align: left;
        position: relative;
        color: #2D5EA3;
        cursor: pointer;

        .result-table-mobile__label {
          color: #2D5EA3;
        }

        .result-table-mobile__label::after {
          content: '';
          display: inline-block;
          line-height: 1.5em;
          background-image: url("../../assets/arr.svg");
          height: .5625em;
          width: .375em;
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
          vertical-align: center;
          margin: 0 0.5em;
        }
      }
    }

    &__label {
      color: rgba(75, 81, 87, 0.7);
      margin-bottom: 0.25em;
    }
  }
</style>
